export enum State {
  Close = 'close',
}

export enum Color {
  White = 'white',
  Gray = 'gray',
  NoColor = '',
}
